import * as React from 'react'
import { graphql } from 'gatsby'
import LeasingDetailsPage from '../../views/leasingDetailsView'

const BuyoutPersonalFinance = (props) => (
  <LeasingDetailsPage
    {...props}
    calculatorType="personal-finance-buyout"
    // productFeatureType="personal-finance-buyout"
    hideCalculator={true}
  />
)

export default BuyoutPersonalFinance

export const query = graphql`
  query BuyoutPFQuery($slug: String, $locale: String) {
    header: contentfulHeader(node_locale: { eq: $locale }) {
      ...headerFragment
    }
    footer: contentfulFooter(node_locale: { eq: $locale }) {
      ...footerFragment
    }
    waitingList: contentfulCtaSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...waitingListFragment
    }
    hero: contentfulHeroSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...heroFragment
    }
    page: contentfulPage(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      metaDescription
      metaTag
      title
      slug
      sections: pageSection {
        ...leasingDetailFeaturesFragment
        ...leasingDetailSectionFragment
      }
    }
  }
`
